"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _react2 = require("@headlessui/react");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faChevronDown = require("@fortawesome/pro-regular-svg-icons/faChevronDown");

var _faChevronUp = require("@fortawesome/pro-regular-svg-icons/faChevronUp");

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _AccordionContent = _interopRequireDefault(require("./AccordionContent"));

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Icon = function Icon() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center justify-center w-full py-10"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faChevronDown.faChevronDown,
    size: "6x"
  }));
};

var FONT_SIZES = ['xs', 'sm', 'md', 'lg', 'xl', '2xl'];

var AccordionComponent = function AccordionComponent(_ref) {
  var _window, _window$location, _window4, _window4$location;

  var _ref$state = _ref.state,
      _ref$state$headerColo = _ref$state.headerColour,
      headerColour = _ref$state$headerColo === void 0 ? '#000000' : _ref$state$headerColo,
      headerHoverColour = _ref$state.headerHoverColour,
      _ref$state$headerFont = _ref$state.headerFontWeight,
      headerFontWeight = _ref$state$headerFont === void 0 ? 'normal' : _ref$state$headerFont,
      _ref$state$headerFont2 = _ref$state.headerFontSize,
      headerFontSize = _ref$state$headerFont2 === void 0 ? 3 : _ref$state$headerFont2,
      _ref$state$headerBack = _ref$state.headerBackgroundColour,
      headerBackgroundColour = _ref$state$headerBack === void 0 ? 'transparent' : _ref$state$headerBack,
      headerBackgroundHoverColour = _ref$state.headerBackgroundHoverColour,
      _ref$state$headerFont3 = _ref$state.headerFont,
      headerFont = _ref$state$headerFont3 === void 0 ? 'body' : _ref$state$headerFont3,
      _ref$state$borderColo = _ref$state.borderColour,
      borderColour = _ref$state$borderColo === void 0 ? '' : _ref$state$borderColo,
      _ref$state$accordion = _ref$state.accordion,
      accordion = _ref$state$accordion === void 0 ? [] : _ref$state$accordion,
      _ref$state$selectedAc = _ref$state.selectedAccordionIndex,
      selectedAccordionIndex = _ref$state$selectedAc === void 0 ? 0 : _ref$state$selectedAc,
      isEditMode = _ref.isEditMode,
      focused = _ref.focused,
      onChange = _ref.onChange;
  var StyledHeader = (0, _styled["default"])(_react2.Disclosure.Button)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        background-color: ", ";\n        color: ", ";\n\n        &:hover {\n            color: ", ";\n            background-color: ", ";\n        }\n    "])), headerBackgroundColour, headerColour, headerHoverColour || headerColour, headerBackgroundHoverColour || headerBackgroundColour);

  var _useState = (0, _react.useState)(selectedAccordionIndex || 0),
      _useState2 = _slicedToArray(_useState, 2),
      internalAccordionIndex = _useState2[0],
      setInternalAccordionIndex = _useState2[1];

  var inStorefront = !((_window = window) !== null && _window !== void 0 && (_window$location = _window.location) !== null && _window$location !== void 0 && _window$location.pathname.includes('/content/edit/'));
  var defaultIndexes = accordion.map(function (acc, idx) {
    return acc.openByDefault ? idx : null;
  });
  var anchorIndex = accordion.findIndex(function (acc) {
    var _window2, _window2$location;

    if ((_window2 = window) !== null && _window2 !== void 0 && (_window2$location = _window2.location) !== null && _window2$location !== void 0 && _window2$location.hash) {
      return acc.anchor === window.location.hash.replace('#', '');
    } else {
      return false;
    }
  });
  (0, _react.useEffect)(function () {
    var _window3, _window3$location;

    if ((_window3 = window) !== null && _window3 !== void 0 && (_window3$location = _window3.location) !== null && _window3$location !== void 0 && _window3$location.hash) {
      var _document, _document$querySelect;

      (_document = document) === null || _document === void 0 ? void 0 : (_document$querySelect = _document.querySelector(window.location.hash)) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.scrollIntoView();
    }
  }, [(_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$location = _window4.location) === null || _window4$location === void 0 ? void 0 : _window4$location.hash]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (accordion === null || accordion === void 0 ? void 0 : accordion.length) > 0 ? /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "accordion"
  }, accordion === null || accordion === void 0 ? void 0 : accordion.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_react2.Disclosure, {
      key: "accordion-".concat(index),
      defaultOpen: item.openByDefault
    }, function (_ref2) {
      var open = _ref2.open;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "content__accordion",
        "data-testid": "accordion__item-".concat(index),
        style: {
          boxShadow: selectedAccordionIndex === index && focused && 'inset 0 0 0 3px yellow',
          borderBottom: borderColour ? '1px solid' : 'none',
          borderColor: borderColour || 'transparent'
        }
      }, /*#__PURE__*/_react["default"].createElement(StyledHeader, _extends({
        className: "w-full active:border-0 focus:outline-none pt-[10px] px-[15px] pb-[15px]"
      }, isEditMode && {
        onClick: function onClick() {
          setInternalAccordionIndex(index);
          onChange({
            selectedAccordionIndex: index
          });
        }
      }, {
        style: {
          fontSize: FONT_SIZES[headerFontSize],
          fontWeight: headerFontWeight
        },
        "data-testid": "accordion__item-".concat(index, "--header")
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: " flex items-center justify-between font-bold text-lg"
      }, item.label, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: open ? _faChevronUp.faChevronUp : _faChevronDown.faChevronDown
      }))), /*#__PURE__*/_react["default"].createElement(_react2.Disclosure.Panel, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "my-[15px] px-[15px]"
      }, /*#__PURE__*/_react["default"].createElement(_AccordionContent["default"], {
        content: item.text
      }))));
    });
  })) : inStorefront ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null) : /*#__PURE__*/_react["default"].createElement(Icon, null));
};

var _default = AccordionComponent;
exports["default"] = _default;